export default "__VITE_ASSET__CM$RSUJd__"